import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingSetItemWrapper: {
    padding: theme.spacing(0.5, 1),
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },

  started: {
    background: theme.palette.exerciseStatus.started,
  },
  notStartedOddLine: {
    background: theme.palette.exerciseStatus.notStartedOddLine,
  },
  notStartedEvenLine: {
    background: theme.palette.exerciseStatus.notStartedEvenLine,
  },
  doLateOddLine: {
    background: theme.palette.exerciseStatus.doLateOddLine,
  },
  doLateEvenLine: {
    background: theme.palette.exerciseStatus.doLateEvenLine,
  },
  skippedOddLine: {
    background: theme.palette.exerciseStatus.skippedOddLine,
  },
  skippedEvenLine: {
    background: theme.palette.exerciseStatus.skippedEvenLine,
  },
  finishedOddLine: {
    background: theme.palette.exerciseStatus.finishedOddLine,
  },
  finishedEvenLine: {
    background: theme.palette.exerciseStatus.finishedEvenLine,
  },
  menuContainer: {
    width: '150px',
    maxWidth: '150px',
    minWidth: '150px',
  },
  menuItemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  optionFieldContainer: {
    '& .MuiOutlinedInput-root.MuiInputBase-root': {
      paddingLeft: '0 !important',
    },
  },
}));
